// extracted by mini-css-extract-plugin
module.exports = {"container":"b429494557--container--q5jzO","item":"b429494557--item--y86vU","house":"b429494557--house--EFKX_","newbuilding":"b429494557--newbuilding--fz_pm"};